function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "FillColor",
  d: "M10.3228 27.2958C10.5009 27.1456 10.7173 27.0482 10.9478 27.0145C11.1543 26.9828 11.3656 27.0034 11.5621 27.0743C11.7586 27.1453 11.9342 27.2644 12.0729 27.4208L14.5729 30.1708C14.6884 30.291 14.7787 30.4331 14.8385 30.5887C14.8983 30.7444 14.9264 30.9104 14.9211 31.0771C14.9157 31.2437 14.8771 31.4076 14.8075 31.5591C14.7379 31.7106 14.6386 31.8467 14.5156 31.9593C14.3926 32.0719 14.2483 32.1587 14.0913 32.2147C13.9342 32.2706 13.7675 32.2946 13.6011 32.2852C13.4346 32.2758 13.2717 32.2332 13.1219 32.1598C12.9722 32.0865 12.8386 31.984 12.7291 31.8583L12.3853 31.4833V37.327C12.3874 37.4925 12.3566 37.6567 12.2947 37.8102C12.2328 37.9637 12.1411 38.1034 12.0248 38.2212C11.9085 38.3389 11.77 38.4324 11.6173 38.4962C11.4646 38.56 11.3008 38.5929 11.1353 38.5929C10.9698 38.5929 10.806 38.56 10.6533 38.4962C10.5006 38.4324 10.3621 38.3389 10.2458 38.2212C10.1295 38.1034 10.0378 37.9637 9.97587 37.8102C9.91399 37.6567 9.88321 37.4925 9.8853 37.327V30.9833L9.0728 31.6708C8.94785 31.7791 8.8027 31.8615 8.64572 31.9134C8.48873 31.9654 8.32303 31.9857 8.15815 31.9732C7.99328 31.9607 7.8325 31.9158 7.6851 31.8409C7.5377 31.766 7.40658 31.6626 7.29932 31.5368C7.19206 31.411 7.11077 31.2652 7.06015 31.1078C7.00952 30.9504 6.99057 30.7845 7.00437 30.6197C7.01818 30.455 7.06447 30.2945 7.14057 30.1478C7.21668 30.001 7.3211 29.8707 7.4478 29.7645L10.3228 27.2958Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "FillColor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.4708 19.8853C34.4154 20.4166 35 21.4162 35 22.5V25.7014L36.5 24.8014V20.2545L15.4616 8.42046L14.2437 9.07003L33.4708 19.8853ZM32 22.5V31L39.5 26.5V18.5L15.5 5L8 9L32 22.5Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "FillColor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 13V40.5L24 54L48 40.5V13L24 0L0 13ZM24 3.41184L4.72408 13.853L24 24.2941L43.2759 13.853L24 3.41184ZM45 16.3309L25.5 26.8934V49.7142L45 38.7455V16.3309ZM22.5 26.8934L3 16.3309V38.7455L22.5 49.7142V26.8934Z",
  fill: "black"
});

var SvgFreight = function SvgFreight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 54,
    viewBox: "0 0 48 54",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFreight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/freight.1a6fa6f1.svg";
export { ForwardRef as ReactComponent };